import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxSelectBoxComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { moduli } from '../../config';
import { IspisPlanaService } from './ispis-plana.service';
import { PdfZaIspisPlanaNovoService } from 'src/app/pdf-ovi/pdfZaIspisPlana_novi.service';
// import pdfMake from 'pdfmake/build/pdfmake';
const pdfMake = require('pdfmake/build/pdfmake.js');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-ispis-plana',
  templateUrl: './ispis-plana.component.html',
  styleUrls: ['./ispis-plana.component.scss'],
})
export class IspisPlanaComponent implements OnInit {
  @ViewChild('selectBoxPogon', { static: false })
  selectBoxPogon: DxSelectBoxComponent;
  @ViewChild('selectBoxLinija', { static: false })
  selectBoxLinija: DxSelectBoxComponent;
  @ViewChild('selectBoxSkladisteSirovina', { static: false })
  selectBoxSkladisteSirovina: DxSelectBoxComponent;

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');

  planovi: any;
  sirovine: any;
  ambalaza: any;
  planovi_novi_nacin: any = [];
  planovi_za_ispis: any = [];
  sirovine_novi_nacin: any = [];
  sirovine_za_ispis: any = [];
  ambalaza_novi_nacin: any = [];
  ambalaza_za_ispis: any = [];
  smjene: any;
  linije: any;
  pogoni: any;
  skladistaSirovina: any = [];
  nazivPogona: string;
  nazivLinije: string;
  od = '';
  do = '';
  skl = '';
  s = '';
  pog = '';
  l = '';
  poruka: any;
  today: Date = new Date();

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: IspisPlanaService, private router: Router, private ispisPlanaNovoService: PdfZaIspisPlanaNovoService,) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.smjene = [
      { id: '', naziv: 'SVE' },
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];
    this.linije = [{ id: '', naziv: 'SVE' }];
    this.pogoni = [{ id: '', naziv: 'SVE' }];
    this.skladistaSirovina = [{ idposlovnica: '', po_naziv: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().ispisPlana;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveLinije();
    this.dohvatiSvePogone();
    this.dohvatiSkladistaSirovina();
    this.od = moment(this.today).format('YYYY-MM-DD');
    this.do = moment(this.today).format('YYYY-MM-DD');
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  dohvatiPlanove(dod, ddo, skl, s, pog, l) {
    let objekt = {
      datumod: dod,
      datumdo: ddo,
      idposlovnica_skladiste_sirovina: skl,
      smjena: s,
      idpogon: pog,
      brojlinije: l,
    };
    //console.log(objekt);
    this.planovi = [];
    this.service.ispisPlana(objekt).subscribe((res) => {
      //console.log(res);
      this.planovi = res.podaci;
      this.sirovine = res.podacisirovine;
      this.ambalaza = res.podaciambalaza;
    });

    this.planovi_novi_nacin = [];
    this.sirovine_novi_nacin = [];
    this.ambalaza_novi_nacin = [];
    this.planovi_za_ispis = [];
    this.sirovine_za_ispis = [];
    this.ambalaza_za_ispis = [];
    this.service.ispisPlanaNovi(objekt).subscribe((res) => {
      //console.log(res);
      this.planovi_novi_nacin = res.podaci;
      this.sirovine_novi_nacin = res.podacisirovine;
      this.ambalaza_novi_nacin = res.podaciambalaza;

      let indexvariable;
      for (let i = 0; i < this.planovi_novi_nacin.length; i++) {
        indexvariable = this.planovi_za_ispis.findIndex((obj: any) => obj.idLinije == this.planovi_novi_nacin[i].pp_brojlinije);
        if(indexvariable == -1){
          this.planovi_za_ispis.push({ idLinije: this.planovi_novi_nacin[i].pp_brojlinije, nazivLinije: this.planovi_novi_nacin[i].li_naziv, proizvodArray: [this.planovi_novi_nacin[i]] });
        }else{
          this.planovi_za_ispis[indexvariable].proizvodArray.push(this.planovi_novi_nacin[i]);
        }
      }
      //console.log('planovi_za_ispis: ', this.planovi_za_ispis);

      let indexvariable2;
      for (let i = 0; i < this.sirovine_novi_nacin.length; i++) {
        indexvariable2 = this.sirovine_za_ispis.findIndex((obj: any) => obj.idLinije == this.sirovine_novi_nacin[i].pp_brojlinije);
        if(indexvariable2 == -1){
          this.sirovine_za_ispis.push({ idLinije: this.sirovine_novi_nacin[i].pp_brojlinije, nazivLinije: this.sirovine_novi_nacin[i].li_naziv, sirovinaArray: [this.sirovine_novi_nacin[i]] });
        }else{
          this.sirovine_za_ispis[indexvariable2].sirovinaArray.push(this.sirovine_novi_nacin[i]);
        }
      }
      //console.log('sirovine_za_ispis: ', this.sirovine_za_ispis);

      let indexvariable3;
      for (let i = 0; i < this.ambalaza_novi_nacin.length; i++) {
        indexvariable3 = this.ambalaza_za_ispis.findIndex((obj: any) => obj.idLinije == this.ambalaza_novi_nacin[i].pp_brojlinije);
        if(indexvariable3 == -1){
          this.ambalaza_za_ispis.push({ idLinije: this.ambalaza_novi_nacin[i].pp_brojlinije, nazivLinije: this.ambalaza_novi_nacin[i].li_naziv, ambalazaArray: [this.ambalaza_novi_nacin[i]] });
        }else{
          this.ambalaza_za_ispis[indexvariable3].ambalazaArray.push(this.ambalaza_novi_nacin[i]);
        }
      }
      //console.log('ambalaza_za_ispis: ', this.ambalaza_za_ispis);

    });
  }

  onCellPrepared(options) {
    // console.log(options);
    // if (options.rowType == 'data' && options.columnIndex == 8) {
    //   if (options.value == 'L') {
    //     options.cellElement.classList.add('circleYellow');
    //   }
    //   if (options.value == 'O') {
    //     options.cellElement.classList.add('circleRed');
    //   }
    //   if (options.value == 'Z') {
    //     options.cellElement.classList.add('circleGreen');
    //   }
    // }
    // if (options.rowType == 'data' && options.columnIndex == 9) {
    //   if (options.value == '1') {
    //     options.cellElement.classList.add('bojaSmjena1');
    //   }
    //   if (options.value == '2') {
    //     options.cellElement.classList.add('bojaSmjena2');
    //   }
    //   if (options.value == '3') {
    //     options.cellElement.classList.add('bojaSmjena3');
    //   }
    // }
  }

  promjenaDatumOd(e) {
    // console.log(e);
    this.od = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  promjenaDatumDo(e) {
    // console.log(e);
    this.do = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  promjenaSmjene(e) {
    // console.log(e);
    this.s = e.value;
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  promjenaSkladista(e){
    // console.log(e);
    this.skl = e.value;
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  promjenaPogona(e){
    //console.log(e);
    let test = this.selectBoxPogon.instance.option();
    this.nazivPogona = test.displayValue;
    this.pog = e.value;
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  promjenaLinije(e) {
    // console.log(e);
    let test = this.selectBoxLinija.instance.option();
    this.nazivLinije = test.displayValue;
    this.l = e.value;
    this.dohvatiPlanove(this.od, this.do, this.skl, this.s, this.pog, this.l);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
  onToolbarPreparingSirovine(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
  onToolbarPreparingAmbalaza(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      //console.log(res);
      this.linije = [{ id: '', naziv: 'SVE' }];
      if (res.success == true) {
        for (let linija of res.data) {
          //console.log(linija);
          this.linije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
        }
        //console.log(this.linije);
      }
    });
  }

  dohvatiSvePogone(){
    this.service.pogoni({idkorisnik: this.idkorisnik, idfirma: this.idfirma}).subscribe((res) => {
      //console.log(res);
      this.pogoni = [{ id: '', naziv: 'SVE' }];
      if (res.success == true) {
        for (let pogon of res.data) {
          //console.log(pogon);
          this.pogoni.push({
            id: pogon.idpogon,
            naziv: pogon.pogon_naziv,
          });
        }
        //console.log(this.pogoni);
      }
    });
  }

  dohvatiSkladistaSirovina() {
    this.service.dohvatiSkladista({}).subscribe((res) => {
      //console.log('SKLADIŠTA: ', res);
      this.skladistaSirovina = [];
      this.skladistaSirovina = [{ idposlovnica: '', po_naziv: 'SVE' }];
      if (res.success == true) {
        //4- skladište gotovih proizvoda, 5- skladište sirovina, 6- skladišta ambalaže
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].idvrstaposlovnice === 5) {
            this.skladistaSirovina.push({
              idposlovnica: res.data[i].idposlovnica,
              po_naziv: res.data[i].po_naziv
            });
          }
        }
        //console.log('SKLADIŠTA SIROVINA:', this.skladistaSirovina);
      }
    });
  }

  createPdf() {
    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];
    ct.push({
      text: 'Ispis plana proizvodnje i sirovina',
      style: 'mainTitle',
    });
    ct.push({
      text: [
        `Datum: ${moment(this.od).format('DD.MM.YYYY.')} - ${moment(
          this.do
        ).format('DD.MM.YYYY.')}
        Smjena: ${!this.s ? 'SVE' : this.s}
        Pogon: ${!this.pog ? 'SVE' : this.nazivPogona} 
        Linija: ${!this.l ? 'SVE' : this.nazivLinije}`,
      ],
      style: 'subtitle',
      margin: [0, 15, 0, 30],
    });

    ct.push({
      text: 'Proizvodi',
      style: 'subtitle',
      margin: [0, 0, 0, 5],
    });
    ct.push({
      table: {
        widths: [40, 300, 50, 40, 40],
        body: [
          [
            'Šifra',
            'Naziv artikla',
            { text: 'Količina', alignment: 'right' },
            { text: 'Kartona', alignment: 'right' },
            { text: 'Paleta', alignment: 'right' },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });
    ct.push(hLine);
    for (let proizvod of this.planovi) {
      ct.push({
        table: {
          widths: [40, 300, 50, 40, 40],
          body: [
            [
              proizvod.ar_sifra,
              proizvod.ar_naziv,
              { text: proizvod.ukupnakolicina, alignment: 'right' },
              { text: proizvod.ukupnokartonanapaleti, alignment: 'right' },
              { text: proizvod.ukupanbrojpaleta, alignment: 'right' },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }
    ct.push(hLine);

    ct.push({
      text: 'Sirovine',
      style: 'subtitle',
      margin: [0, 15, 0, 5],
    });
    ct.push({
      table: {
        widths: [40, 170, 50, 40, 40, 55, 50],
        body: [
          [
            'Šifra',
            'Stavka',
            { text: 'Količina', alignment: 'right' },
            'Jed.mj.',
            { text: 'Izdano', alignment: 'right' },
            { text: 'Vraćeno', alignment: 'right' },
            { text: 'Dodatno', alignment: 'right' },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });
    ct.push(hLine);
    for (let sirovina of this.sirovine) {
      ct.push({
        table: {
          widths: [40, 170, 50, 40, 50, 50, 50],
          body: [
            [
              sirovina.normativsifra,
              sirovina.normativstavske,
              { text: sirovina.kolicinanormativ, alignment: 'right' },
              sirovina.jedinicamjere_JM_SIFRA,
              // { text: sirovina.skladiste_sirovina, alignment: 'right' },
              // { text: sirovina.skladiste_sirovinabr2, alignment: 'right' },
              // { text: sirovina.skladiste_mrvica, alignment: 'right' },
              { text: '__________', alignment: 'right' },
              { text: '__________', alignment: 'right' },
              { text: '__________', alignment: 'right' },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }
    ct.push(hLine);

    ct.push({
      text: 'Ambalaža',
      style: 'subtitle',
      margin: [0, 15, 0, 5],
    });
    ct.push({
      table: {
        widths: [40, 300, 50, 50],
        body: [
          [
            'Šifra',
            'Stavka',
            { text: 'Količina', alignment: 'right' },
            { text: 'Stanje skladišta', alignment: 'right' },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });
    ct.push(hLine);
    for (let ambalaza of this.ambalaza) {
      ct.push({
        table: {
          widths: [40, 300, 50, 50],
          body: [
            [
              ambalaza.artikl_ar_asifra_abbalaze,
              ambalaza.ar_naziv,
              { text: ambalaza.ukupnoambalaza, alignment: 'right' },
              { text: ambalaza.skladisteambalaze, alignment: 'right' },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }
    ct.push(hLine);

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      text: 'Dodatno',
      style: 'subtitle',
      margin: [0, 20, 0, 5],
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      table: {
        widths: [500],
        body: [
          [{ text: 'Vezice:     _______________________', alignment: 'left' }],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      table: {
        widths: [500],
        body: [
          [{ text: 'Strech:     _______________________', alignment: 'left' }],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      table: {
        widths: [500],
        body: [
          [
            {
              text: 'Selotejp:     _______________________',
              alignment: 'left',
            },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      table: {
        widths: [500],
        body: [
          [
            {
              text: 'Deklaracija:     _______________________',
              alignment: 'left',
            },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              //PRAZAN RED
              [''],
              [''],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    ct.push({
      table: {
        widths: [500],
        body: [
          [
            {
              text: 'Paletna deklaracija:     _______________________',
              alignment: 'left',
            },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });
    ct.push(hLine);

    var dd = {
      info: {
        title: `Datum: ${moment(this.od).format('DD.MM.YYYY.')} - ${moment(
          this.do
        ).format('DD.MM.YYYY.')}`,
      },
      content: ct,
      footer: function (currentPage: any, pageCount: any) {
        return {
          columns: [
            {
              text: `${moment().format('DD.MM.YYYY. HH:mm')}`,
              style: 'footer',
            },
            {
              text: `${currentPage.toString()}/${pageCount}`,
              style: 'footer',
              alignment: 'right',
            },
          ],
          margin: 15,
        };
      },
      pageMargins: [15, 15, 15, 35],
      defaultStyle: {
        fontSize: 9.5,
      },
      styles: {
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        subtitle: {
          fontSize: 13,
        },
        footer: {
          fontSize: 10,
          color: 'gray',
        },
      },
    };
    pdfMake.createPdf(dd).open();
  }

  createPdf_novi_nacin(){
    let podac = {
      od: this.od,
      do: this.do,
      s: this.s,
      p: this.pog,
      nazivPogona: this.nazivPogona,
      l: this.l,
      nazivLinije: this.nazivLinije
    }
    this.ispisPlanaNovoService.pdfIspisPlanaNovo(podac, this.planovi_za_ispis, this.sirovine_za_ispis, this.ambalaza_za_ispis);
  }
}
